import { GuidanceSessionType, type MessageTemplate } from '@fruitful/types';

// TODO commit to data model and move to database
// NOTE: These are only temporarily defined here in code while we refine the requirements/design/model.
export const MESSAGE_TEMPLATES: MessageTemplate[] = [
    {
        id: '0',
        createdAt: '2025-07-15',
        updatedAt: '2026-09-17',
        category: 'Kickoff',
        name: 'Welcome Message',
        template: `Hi **[MEMBER_NAME]**! Welcome to Fruitful!

I can see you already have the draft of your first Money Map with real numbers and goals in it! Our first session is all about confirming what you've built, filling in any gaps, and getting your system **live** by the time we hang up.

While there's no extra prep needed before our session, logging into your account and completing your Profile will help us build your Money Map in a way that truly works for you. If you have questions as you move through it, just send me a message and I'll be happy to help.

Looking forward to kicking things off!`,
    },

    {
        id: '5',
        createdAt: '2024-11-01',
        updatedAt: '2026-09-15',
        category: 'Kickoff',
        name: 'Kickoff Follow Up',
        template: `Hey **[MEMBER_NAME]**!

Really pumped about what we mapped out today with your money system!

**Your Money Map is now live!**
Head to the [Money System tab](https://my.fruitful.com/home/roadmap ) in your member dashboard to get started. Follow the quick prompts to open your accounts and set up your Income Split — it just takes a few minutes and puts your money system in motion.

This is the step that turns your plan into real momentum. Once your system is running, your money will automatically start flowing toward your goals — saving you time, mental energy, and decision fatigue.

- You'll see a checklist from today in your [Tasks](https://my.fruitful.com/roadmap/tasks ). Pop over there and let me know if you have any questions.
- When you have a moment, feel free to explore the [Cash & Card](https://www.fruitful.com/cash-and-card ) and [Investing](https://www.fruitful.com/invest ) features included in your membership to learn more about how this all works and all the perks!

If anything comes up before we meet again, just send me a message here!`,
    },
    {
        id: '53',
        createdAt: '2026-09-23',
        updatedAt: '2026-09-23',
        category: 'Kickoff',
        name: 'Kickoff Welcome – Adding Partner',
        template: `Hi **[MEMBER_NAME]**! Welcome to Fruitful!

I can see you already have the draft of your first Money Map with real numbers and goals in it! Our first session is all about confirming what you've built, filling in any gaps, and getting your system **live** by the time we hang up.

While there's no extra prep needed before our session, logging into your account and completing your Profile will help us build your Money Map in a way that truly works for you. If you have questions as you move through it, just send me a message and I'll be happy to help.

It also looks like you have a partner in this process. You can add them to your membership in the app before our session, or send me their email and I can invite them. This will allow me to provide joint guidance and give you both access to the work we're doing together.

Looking forward to kicking things off!`,
    },
    {
        id: '54',
        createdAt: '2026-10-27',
        updatedAt: '2026-10-27',
        category: 'Kickoff',
        name: 'GOYO Welcome Message',
        template: `Hi **[MEMBER_NAME]**! Welcome to Fruitful!

I see you've already set up your Money Map and opened some accounts on your own, which is a great start! In our session, we'll review your setup together, make sure it fits your goals, and get investing in the mix. If you haven't moved your direct deposit yet, we'll make sure you know how to do that too.

There's no prep needed before we meet, but if you have a few minutes, finishing your Profile will help us make the most of our time together. And if there's anything specific on your mind before we connect, I'm here.

Looking forward to kicking things off!`,
    },
    {
        id: '6',
        createdAt: '2024-11-01',
        updatedAt: '2026-09-15',
        category: 'General Session Reminder',
        name: 'Missing Info Reminder 1',
        template: `Hey **[MEMBER_NAME]**,

Looking forward to picking things back up with you! I've started prepping ahead of our session and wanted to check in on how you're coming along with your checklist, here in [Goals](https://my.fruitful.com/roadmap/tasks ).

It'd be great to have a few items knocked out, or even just an update, so I can come prepared with real insights and we can make the most of our time together.

If timing's tough, no worries, we'll keep things moving either way.

See you then!`,
    },
    {
        id: '9',
        createdAt: '2024-11-01',
        updatedAt: '2026-09-15',
        category: 'Session 3',
        name: 'Statements Reminder',
        template: `Hi **[MEMBER_NAME]**,

Since we're getting your full system dialed in, it feels like a good time to circle back on those **[investment account / 401k / IRA / Roth IRA / etc]** statement(s) you mentioned. Could you please send over statement(s) for those/that account when you get the chance? I'll take a look and we can talk through it together during our next session if there's time!`,
    },
    {
        id: '10',
        createdAt: '2024-11-01',
        updatedAt: '2026-09-15',
        category: 'Optimize',
        name: 'Optimize Follow Up',
        template: `Hi **[MEMBER_NAME]**!

Great working through everything today! Your system is fully up and running and in a solid place, aligned with the goals that brought you here. That's worth feeling good about!

Today was our last session, but you still have support in your corner! You can message me anytime. I'd love to hear how setup wraps up and how the system we built starts taking shape over the next couple of weeks.

And you don't have to do it alone — we're here every step of the way:
- Email **support@fruitful.com** for membership, billing, or technical banking questions
- Leave us a voicemail at **(833) 789-2219**. Someone from our team will email or call you back within 1-2 business days.

At the end of your trial, you'll have two options. If you'd like to keep ongoing 1:1 support with me, you can upgrade to a Premium Memberhip, which includes messaging and additional sessions. Otherwise, you can stick with a Fruitful Membership (with no membership fees) and keep your money system running exactly as it is, just a bit more self-service. You'll see all the details in the app as your trial wraps up so you can choose what works best for you.`,
    },
    {
        id: '11',
        createdAt: '2024-11-01',
        updatedAt: '2025-07-15',
        category: 'Check In',
        name: 'Check In / Milestone Follow Up',
        template: `Hey **[MEMBER_NAME]**!

It was great catching up today! I'm excited about the progress you've made, and together we've built a solid foundation for your financial goals.

Remember, your to-dos are in the [Goals & Tasks](https://my.fruitful.com/roadmap/tasks ) section of your member app. As you check them off, you'll keep that momentum going!

Thank you for sharing your feedback and insights today — we always love hearing from you! [Please click here to fill out your Member Survey](https://forms.gle/ASfBf4kuqTZi8kGM8? ). Your responses help our product, guidance, and engineering teams continue improving and expanding the membership experience.

Looking forward to our next check-in! Feel free to message me anytime if you have questions or updates.`,
    },
    {
        id: '14',
        createdAt: '2024-11-01',
        updatedAt: '2025-07-12',
        category: 'General / Reminders',
        name: 'No Show',
        template: `Hi **[MEMBER_NAME]**, sorry I missed you today! Feel free to reschedule when you're ready in the [Guidance tab](https://my.fruitful.com/home/my-guide ). Let me know if you need anything else in the meantime!`,
    },
    {
        id: '15',
        createdAt: '2024-11-01',
        updatedAt: '2025-07-12',
        category: 'General / Reminders',
        name: 'Market Volatility Concerns',
        template: `I totally understand your concerns about market volatility — it's completely normal to feel uneasy when things are up and down. But remember, market cycles like this are part of the process, and historically, they've always balanced out over time. The key is sticking to the plan we've put in place, which is designed to weather these ups and downs and keep you on track toward your long-term goals.

By staying the course, you're setting yourself up for success, and reacting emotionally to short-term market shifts can sometimes derail that progress. If you ever want to talk through anything, I'm here!`,
    },
    {
        id: '17',
        createdAt: '2024-11-01',
        updatedAt: '2025-07-15',
        category: 'FAQ',
        name: 'Security Questions',
        template: `We take security extremely seriously. We know you entrust us with your finances, and we take that responsibility personally. When you give us information, we make sure only the people you shared it with can see it, we encrypt it in transit and at rest, and we have best-in-class security practices in place to make sure bad actors can never get to it.

We do all the standard security things that you'd expect (multi-factor authentication, end-to-end encryption, regular third-party security assessments, continuous monitoring, employee training, etc.), but more importantly, security is just deeply ingrained into our culture. Our guides painstakingly safeguard your personal information, our banking team actively scans your account for suspicious activity, and our engineering team proactively defends against the latest cyber threats.`,
    },
    {
        id: '18',
        createdAt: '2024-11-01',
        updatedAt: '2026-09-15',
        category: 'FAQ',
        name: "Extra Security Questions / Won't Link Accounts",
        template: `Hi **[MEMBER_NAME]**, we really appreciate your concerns! These processes have been established to ensure efficiency and consistency across our operations. If you find that our approach doesn't align with your expectations, we completely respect your decision if you choose to look elsewhere for your financial wellness needs.`,
    },
    {
        id: '19',
        createdAt: '2024-11-01',
        updatedAt: '2024-11-01',
        category: 'FAQ',
        name: 'Why Link Accounts',
        template: `For both you and your Guide, linking your accounts makes it really easy to stay up to date and accurate on your financial world. It means we don't have to manually track and update accounts consistently, creating one centralized reference so we can provide quicker, more informed answers and advice. It'll also be the foundation that powers helpful future feature releases that make navigating your finances even simpler.`,
    },
    {
        id: '20',
        createdAt: '2024-11-01',
        updatedAt: '2024-11-01',
        category: 'FAQ',
        name: 'Update payment method',
        template: `You can update your payment method [via Stripe](https://billing.stripe.com/p/login/eVabLl0ExeXYbXa144 )`,
    },
    {
        id: '21',
        createdAt: '2024-11-01',
        updatedAt: '2024-11-01',
        category: 'FAQ',
        name: 'Why Keep Membership Long Term',
        template: `Managing your money isn't a one-and-done task — it's an ongoing journey that evolves as your life changes. Your financial situation and even your goals will shift over time, and that's completely natural. Instead of starting from scratch with a new advisor every time life throws a curve ball or relying on generic advice from AI, Fruitful members have something better: access to a human expert who truly understands your unique situation.

At Fruitful, we believe in building a system that works for you automatically, adapting as your needs change. Whether it's adjusting your savings strategy, tweaking your Free to Spend account, or making sure your investments align with your goals, we're here to help you stay on track. While traditional financial advice hasn't always been built for everyone, one thing they got right is having someone in your corner for the long haul—and at Fruitful, that's exactly what you get.`,
    },
    {
        id: '25',
        createdAt: '2025-07-15',
        updatedAt: '2025-07-15',
        category: 'Check In',
        name: 'Pre-Check in prep',
        template: `Hi **[MEMBER_NAME]**,
We have our Check-In meeting coming up on **[DAY]**. This is a great opportunity to reflect on the progress you've made, review any open action items, and discuss next steps. If there's anything specific you'd like to cover or any updates since our last meeting, feel free to let me know so I can be fully prepared.

See you soon!`,
    },
    {
        id: '31',
        createdAt: '2025-04-04',
        updatedAt: '2026-09-15',
        category: 'FAQ',
        name: 'How does the Fruitful Card work?',
        template: `The Fruitful Card is a **secured charge card**, which means your spending is capped by the cash you hold in your Fruitful Cash Account, and the full statement balance is paid off automatically each month.

Each time you use your card, that spending is reflected in your available Fruitful Cash Account balance. The funds used for those purchases are then set aside (and still earning interest) to cover your transaction, ensuring your statement is covered at the end of the month.

Instead of transactions clearing individually, purchases accumulate throughout the billing cycle. At the end of the cycle, one automatic payment pulls those reserved funds and pays the balance in full — so you never carry a balance or get charged interest.

**Here's what that means for you:**
• Your cash keeps earning interest while purchases accumulate, until the auto-pay date.
• Everything stays streamlined with one simple monthly payment.
• You never carry a balance, never pay interest, and you're always spending within your means, with no surprises.

You can learn more in [the Fruitful Card section of our FAQ](https://www.fruitful.com/cash-and-card#cc-faq-card )`,
    },
    {
        id: '32',
        createdAt: '2025-04-04',
        updatedAt: '2025-07-15',
        category: 'FAQ',
        name: 'Account linking issues',
        template: `Hi **[MEMBER_NAME]**,
Thanks for letting me know. I'm sure this is frustrating, but we've recently made some updates to our account linking experience to make it smoother and more reliable. If you're having any trouble reconnecting your accounts, here are a few things to try:

- **Try reconnecting again**: Sometimes it just works the second or third time.
- **Double-check your login**: Make sure you're using the right username and password.
- **Look for any extra security steps**: You may be asked to enter a code from your phone or email, or may be required to take action in their portal to approve the connection.
- **Search for your bank a little differently**: Some have multiple names (like "Chase" vs. "JP Morgan Chase"), or separate logins for different types of accounts.
- **Wait a bit and try later**: Many institutions sometimes have temporary issues that clear up on their own.

If it's still not working, our Hospitality team is ready to help. Send them an email at support@fruitful.com.`,
    },
    {
        id: '33',
        createdAt: '2025-10-16',
        updatedAt: '2026-10-08',
        category: 'General / Reminders',
        name: 'Waiting in the Zoom',
        template: `Hi **[MEMBER_NAME]**, just checking in! I'm on Zoom and will stick around for another few minutes in case you're running a little behind.

If you aren't able to make it today, you can reschedule in the [Guidance tab](https://my.fruitful.com/home/my-guide ) when you're ready. Let me know if you have any questions in the meantime!`,
    },
    {
        id: '34',
        createdAt: '2025-10-16',
        updatedAt: '2025-10-16',
        category: 'Membership',
        name: 'Married, Signed Up Solo',
        template: `Hi **[MEMBER_NAME]**,

I noticed you listed that you're married filing jointly and wanted to share why adding your partner might be helpful.

You can actually add them for no extra cost, and I highly recommend it. Most couples manage at least some (if not all) of their finances together and share long-term goals, and from a guidance and compliance standpoint, I'm more limited in what I can advise on (especially around retirement) if your partner isn't included.

It's also important if we're building out your money system and need to set up any joint accounts, your partner will need to be listed on your membership in order to be added to those accounts.

And honestly, this goes far beyond just convenience. So many parts of your financial life are connected... taxes, Social Security benefits, estate planning, life insurance coverage, employee benefits, and even how joint debt is managed. When I can see both sides of the picture, I can give advice that's more accurate, strategic, and truly personalized to your situation as a couple.

When both voices are part of the plan, it makes everything easier and more effective. You'll move faster toward your goals, stay more aligned as a team, and get the full value of what your membership offers.

If you'd like to add them, all I need is their email address, and our Support team will take care of the rest.`,
    },
    {
        id: '35',
        createdAt: '2025-12-11',
        updatedAt: '2025-12-11',
        category: 'Membership',
        name: 'Membership Payment Reminder',
        template: `Hi **[MEMBER_NAME]**, Quick reminder to make sure you've made your membership payment this week so we can continue working together. Our hospitality team reached out to you via email with more info!`,
    },
    {
        id: '36',
        createdAt: '2025-12-15',
        updatedAt: '2025-12-15',
        category: 'General / Reminders',
        name: 'Jan Busy Season',
        template: `Hey **[MEMBER_NAME]**! Thanks so much for reaching out. Yes, this time of year is always especially busy for us with so many people setting New Year's money goals. My calendar is a bit tricky! Thanks for your patience!

In the meantime, is there anything I can help with over messaging? I'm happy to share advice async so you can get an answer sooner if it's time-sensitive.`,
    },
    {
        id: '37',
        createdAt: '2025-12-15',
        updatedAt: '2025-12-15',
        category: 'Check In',
        name: 'Check in Upcoming',
        template: `I saw you booked some time for next week — looking forward to connecting. Before we meet, could you share a bit about what you're hoping to cover? Any recent financial updates or specific questions on your mind?

If it's easier, we can also work through everything here in messaging. A lot of members prefer this at the end of the year since it's quick and flexible, and I'm happy to support you this way if that feels better for you. Just let me know what you prefer!`,
    },
    {
        id: '38',
        createdAt: '2026-01-08',
        updatedAt: '2026-09-15',
        category: 'FAQ',
        name: "Why didn't my goals get funded?",
        template: `Hi **[MEMBER_NAME]**
Yup that makes sense that your goals weren't funded yet. Think of your Money Map like a waterfall: a multi-tiered process where funds are allocated in a specific order. Bills and spending are treated as the first tier of the waterfall, ensuring they are funded first up until the monthly caps we've designated. Any remaining funds then "spill over" to goals, which are funded based on their priority. This process resets monthly.

It's important to keep in mind that money allocated for goals may not begin funding until your second paycheck or later in the month—but that's by design. It's structured to protect your core needs first (bills + spend), then accelerate progress when there's extra income. Also note that any interest earned from the Fruitful accounts or the cash back on spending on your Fruitful card will follow these same rules and automatically flow in this same order of priority. So this means your money is always working for you even quietly behind the scenes!`,
    },
    {
        id: '39',
        createdAt: '2026-01-15',
        updatedAt: '2026-01-15',
        category: 'Money Map',
        name: 'Money Map Progress Check In',
        template: `Hi **[MEMBER_NAME]**,

I'd love to hear how things are coming along with your Money Map! Any updates or questions I can help with? You're so close to having everything in place! Think of this as a little accountability nudge to keep our momentum going and a quick check in to see if there's anything I can do to support you in the meantime.

For a limited-time, you may be eligible for a $250 bonus when you receive a qualifying direct deposit in your Fruitful Cash Account [see terms here](https://www.fruitful.com/legal/250-direct-deposit-promo ) to learn if you're eligible!

And you don't have to do it alone - we're here every step of the way:
• Message me directly anytime for personalized guidance
• If you need quick help getting your system set up (like moving a bill or updating direct deposit), **call us at (833) 789-2219** — someone from our team will answer or get back to you quickly
• Email **support@fruitful.com** for membership, billing, or technical banking questions`,
    },
    {
        id: '40',
        createdAt: '2026-02-12',
        updatedAt: '2026-02-12',
        category: 'General / Reminders',
        name: 'Multiple Reschedules Template',
        template: `Hi **[MEMBER_NAME]**,

I noticed we've had to reschedule a few times - that happens. Let's pick back up our momentum!

Come as you are to our next session — we'll use the time to keep things moving forward. Even if it's been a little while or things have shifted, meeting live gives us a chance to reset and get back on track.

We've all been there! I'm here and ready when you are. See you soon!`,
    },
    {
        id: '41',
        createdAt: '2026-02-12',
        updatedAt: '2026-09-15',
        category: 'General / Reminders',
        name: 'Retrieving Tax Documents',
        template: `Hi **[MEMBER_NAME]**,

Here are the steps to retrieve your tax documents. Let me know if you get stuck!

**Fruitful Cash Accounts:**
Go to the **Banking tab** on your homepage → **More…** → **Statements and Docs** → **Taxes Tab**

**Fruitful Investment Accounts:**
1. Log in to your Fruitful member portal
2. Select **Invest** on the Home page
3. Click on an existing account, then select **View Account**
4. In the left-hand menu, go to **Document Vault** → Apex Documents
5. Select the tax year, then click **Tax Statements**`,
    },
    {
        id: '43',
        createdAt: '2026-02-23',
        updatedAt: '2026-02-23',
        category: 'FAQ',
        name: 'Add or Update Pin Number',
        template: `Hi **[MEMBER_NAME]**

To set up or update your PIN, here are the steps:

1. Navigate to the Banking section of your Fruitful portal
2. Tap the account associated with your card (your spend account)
3. Tap View Account
4. Select your physical card
5. Tap Change/Set up PIN`,
    },
    {
        id: '44',
        createdAt: '2026-03-05',
        updatedAt: '2026-03-05',
        category: 'General / Reminders',
        name: 'Earlier Availability Reminder',
        template: `Hi [MEMBER_NAME]!

I had some earlier availability open up and wanted to see if you'd like to meet sooner for our **[Discovery / Money Map]** session.

You can use [this link](https://my.fruitful.com/home/my-guide ) to see the current openings and reschedule. These spots sometimes get grabbed quickly, so go ahead and select a new time if you'd like to meet sooner!`,
    },
    {
        id: '45',
        createdAt: '2026-04-02',
        updatedAt: '2026-04-02',
        category: 'FAQ',
        name: 'Lost or Stolen Card',
        template: `Hi **[MEMBER_NAME]**,

I'm so sorry to hear this! You can lock your physical card in the app and request a replacement by following the steps below.

**Steps to lock your card:**

1. Go to your **Spend account**
2. Tap **View account** and go to the section that shows your cards
3. Select **your Physical card**
4. Toggle **Lock card**

**Steps to order a new card:**

In that same section, tap **Request a replacement card** and follow the prompts. Our Hospitality team will take it from there. Your new card typically arrives within 2–3 business days.

While you're waiting for your new card to arrive, you can continue spending using your **virtual card**, which has a different card number.

If you notice any unfamiliar transactions, please let us know right away or reach out to our Hospitality team at **support@fruitful.com**`,
    },
    {
        id: '46',
        createdAt: '2026-04-23',
        updatedAt: '2026-09-15',
        category: 'FAQ',
        name: 'Card Balance and Autopay',
        template: `No worries, this is an easy fix.

I can see that AutoPay is currently turned off. For this payment, you'll just need to manually release it. Going forward, I'd recommend turning on AutoPay so this happens automatically each billing cycle.

**To turn on AutoPay:**
1. Go to the Banking tab ($ icon)
2. Select the account connected to the card
3. Tap the button showing your card
4. Select the gear icon next to "Your card spend"
5. Toggle AutoPay on and tap Done

A quick refresher on how the Fruitful Card works:

The Fruitful Card is a secured charge card, which means you can only spend against money you already have in your Fruitful Cash Account.

When you make a purchase, that amount is automatically reserved from your balance to cover your future card payment. The money stays in your account earning interest, but it's no longer available to spend elsewhere.

Rather than each transaction clearing individually, your purchases build up throughout the billing cycle. At the end of the cycle, one payment is made from those reserved funds to pay the card balance in full.

So in this case, the money is already set aside. You just need to manually release the payment this time. It won't reduce the amount of cash you currently have available to spend because those funds have already been reserved.

Then, once AutoPay is turned on, this will happen automatically going forward. Let me know if anything is unclear. You can also call our helpline at (833) 789-2219, and someone from the team will be happy to help.`,
    },
    {
        id: '47',
        createdAt: '2026-06-08',
        updatedAt: '2026-06-08',
        category: 'FAQ',
        name: 'Direct Deposit Account Verification',
        template: `You can download a Direct Deposit Account Verification letter easily through your Fruitful app that should allow your employer to get your direct deposit switched over to one of your Fruitful accounts.

1. Navigate to the Banking tab within your Fruitful app
2. Select 'More'
3. Select 'Set up direct deposit'
4. Select 'Switch manually'
5. Select 'Download letter' link located directly above the 'Done' button
6. Select the account you would like your direct deposit to be directed to
7. Click 'Download account verification letter'

Let me know if you have any questions or run into any issues.`,
    },
    {
        id: '48',
        createdAt: '2026-06-08',
        updatedAt: '2026-08-25',
        category: 'FAQ',
        name: 'Account Verification Letter',
        template: `You can download an Account Verification letter that should allow your bill provider to get your bill pay switched over to one of your Fruitful accounts.

1. Head to the **Switch your bills** section of your Money Map set up
2. Under the Fruitful Card, click **Download** letter
3. Select the account you would like your bill connected to
4. Click **Download account verification letter**

Let me know if you have any questions or run into any issues.`,
    },
    {
        id: '49',
        createdAt: '2026-07-30',
        updatedAt: '2026-08-19',
        category: 'General / Reminders',
        name: 'ACCC Referral Link',
        template: `Thank you for sharing your debt so openly today, it takes a lot of courage to be vulnerable! As I mentioned, we've partnered with [American Consumer Credit Counseling (ACCC)](https://partners.consumercredit.com/fruitful/?utm_source=fruitful&utm_medium=referral&utm_campaign=fruitful&utm_channel=fruitful&firstname=**[PRIMARY_MEMBER_FIRST_NAME]**&lastname=**[PRIMARY_MEMBER_LAST_NAME]**&email=**[PRIMARY_MEMBER_EMAIL]**&phone=**[PRIMARY_MEMBER_PHONE]** ), a nonprofit organization, to give Fruitful members a trusted path to managing debt. They've helped many members lower their interest rates and create a clear plan to pay off debt through a Debt Management Plan (DMP).

Reach out to them to learn more about how a Debt Management Plan (DMP) can help you! You can connect with them at the link above or call them directly at 866-426-5033. Feel free to share or upload the proposal details once you've connected with them, and I'd be happy to review with you.`,
    },
    {
        id: '50',
        createdAt: '2026-09-15',
        updatedAt: '2026-09-15',
        category: 'Check In',
        name: 'Proactive Outreach',
        template: `Hi **[MEMBER_NAME]**,

Just checking in — how's everything going? Anything I can help with?`,
    },
    {
        id: '51',
        createdAt: '2026-09-21',
        updatedAt: '2026-09-21',
        category: 'FAQ',
        name: 'Bills - Routing number issues',
        template: `Although we've been [registered with the Federal Reserve](https://www.frbservices.org/EPaymentsDirectory/detailACH.html?referredBy=detailFromAchResults&aba=026073215&displaySearchLinks=true ) since 2022, our routing number is still considered relatively new in the grand scheme of things. This means that some companies' systems don't always recognize it right away. I know this isn't ideal, but the good news is there's an alternative we can try.

Most times, sending over an account verification letter to the merchant or bill processor will help them manually verify and approve the account on their end.

You can download this verification letter following these steps:

1. Head to the FAQs tab of your account settings, found [here](https://my.fruitful.com/settings/faq ) (you may be prompted to log in)
2. In the FAQ page scroll to "What if my provider doesn't recognize Fruitful?"
3. Clicking on the hyperlinked text **"this letter"** will prompt a screen to download your file
4. Select the right account from where the money should be deducted (Bills/Core)

You can then share this letter with your bill provider, and ask them to update your payment method. If that doesn't work, or you have other questions, please let us know! We'll be here to help.`,
    },
];

/**
 * Maps guidance session types to message template categories
 */
const SESSION_TYPE_TO_CATEGORY_MAP: Record<GuidanceSessionType, string[]> = {
    [GuidanceSessionType.DISCOVERY]: ['Kickoff'],
    [GuidanceSessionType.ROADMAP]: ['Optimize'],
    [GuidanceSessionType.BUILDING_WEALTH]: ['Session 3'],
    [GuidanceSessionType.QUICK_CHECK_IN]: ['Check In'],
    [GuidanceSessionType.MEMBER_CALL]: ['Check In'],
    [GuidanceSessionType.WELCOME_CALL]: [],
    [GuidanceSessionType.FREE_INTRO_SESSION]: [],
    [GuidanceSessionType.INVESTMENT_MANAGEMENT]: ['Session 3'],
    [GuidanceSessionType.REVIEW_CAPSTONE]: ['Check In'],
};

/**
 * Gets message templates for a given guidance session type
 * @param sessionType - The guidance session type
 * @returns Array of message templates matching the session type's categories
 */
export function getMessageTemplatesBySessionType(
    sessionType: GuidanceSessionType,
): MessageTemplate[] {
    const categories = SESSION_TYPE_TO_CATEGORY_MAP[sessionType] ?? [];
    if (categories.length === 0) {
        return [];
    }
    return MESSAGE_TEMPLATES.filter((template) =>
        categories.includes(template.category),
    );
}

/**
 * Gets a specific message template by ID
 * @param id - The template ID
 * @returns The message template or undefined if not found
 */
export function getMessageTemplateById(
    id: string,
): MessageTemplate | undefined {
    return MESSAGE_TEMPLATES.find((template) => template.id === id);
}

/**
 * Gets message templates by category
 * @param category - The template category
 * @returns Array of message templates matching the category
 */
export function getMessageTemplatesByCategory(
    category: string,
): MessageTemplate[] {
    return MESSAGE_TEMPLATES.filter(
        (template) => template.category === category,
    );
}
